import React, { useEffect, useState } from "react";
import { Container, Paper, Box, TextField, Button, Typography, Alert } from "@mui/material";

export default function PasscodeGate({ children, areaKey = "orders" }) {
  const LS_KEY = `pass_ok_${areaKey}`;
  const [ok, setOk] = useState(false);
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    if (localStorage.getItem(LS_KEY) === "1") setOk(true);
  }, []);

  const onSubmit = e => {
    e.preventDefault();
    const expected = process.env.REACT_APP_ORDERS_PASSWORD || ""; // cleartext
    if (!expected) return setErr("Missing REACT_APP_ORDERS_PASSWORD at build time.");
    if (pass === expected) {
      localStorage.setItem(LS_KEY, "1");
      setOk(true);
    } else {
      setErr("Wrong password. Try again.");
    }
  };

  if (ok) return <>{children}</>;

  return (
    <Container maxWidth="sm" sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}>
      <Paper sx={{ p: 4, width: "100%", borderRadius: 2 }} elevation={3}>
        <Typography variant="h5" gutterBottom>Enter Password</Typography>
        {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
        <Box component="form" onSubmit={onSubmit} sx={{ display: "grid", gap: 2 }}>
          <TextField
            label="Password"
            type="password"
            value={pass}
            onChange={e => setPass(e.target.value)}
            autoFocus
            required
          />
          <Button type="submit" variant="contained">Unlock</Button>
        </Box>
      </Paper>
    </Container>
  );
}
